import Model, { executeMutation, GqlError, ID, JsonObject } from 'src/models/model'

export default class LibrariableLinkable extends Model {
  static name = 'LibrariableLinkable'

  static define () {
    this.fields = {
      modelClass: {
        type: String,
        output: true
      },
      modelId: {
        type: ID,
        output: true
      },
      libraryDescendants: {
        type: JsonObject,
        output: true
      }
    }

    this.queries = {
      librariableLinkable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          librariableLinkable: LibrariableLinkable
        }
      }
    }

    this.mutations = {
      addOrUpdateLibrariable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          },
          libraryParentId: {
            type: ID,
            required: false
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      enableLibrariable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      disableLibrariable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      syncLibrariable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      deleteLibrariable: {
        arguments: {
          modelClass: {
            type: String,
            required: true
          },
          modelId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }
  }

  static addOrUpdateLibrariable (modelClass, modelId, libraryParentId) {
    return executeMutation(
      'addOrUpdateLibrariable',
      { modelClass, modelId, libraryParentId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  addOrUpdateLibrariable (modelClass, modelId, libraryParentId) {
    return this.constructor.addOrUpdateLibrariable(modelClass, modelId, libraryParentId)
  }

  static syncLibrariable (modelClass, modelId) {
    return executeMutation(
      'syncLibrariable',
      { modelClass, modelId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  syncLibrariable (modelClass, modelId) {
    return this.constructor.syncLibrariable(modelClass, modelId)
  }

  static enableLibrariable (modelClass, modelId) {
    return executeMutation(
      'enableLibrariable',
      { modelClass, modelId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  enableLibrariable (modelClass, modelId) {
    return this.constructor.enableLibrariable(modelClass, modelId)
  }

  static disableLibrariable (modelClass, modelId) {
    return executeMutation(
      'disableLibrariable',
      { modelClass, modelId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  disableLibrariable (modelClass, modelId) {
    return this.constructor.disableLibrariable(modelClass, modelId)
  }

  static deleteLibrariable (modelClass, modelId) {
    return executeMutation(
      'deleteLibrariable',
      { modelClass, modelId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  deleteLibrariable (modelClass, modelId) {
    return this.constructor.deleteLibrariable(modelClass, modelId)
  }
}
